import React from 'react';
import { Spinner } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import { notify, useCacheRecord } from 'gossamer-front-end';
import { Event } from 'cb-model';
import { formatEventUrl } from 'shared-front-end';

export const CaptureAttendanceSuccess = (): React.JSX.Element => {
  const { eventId } = useParams();
  const eventRecord = useCacheRecord(Event, String(eventId));
  const navigate = useNavigate();
  React.useEffect(() => {
    notify(['Thank you for registering your attendance!', 'success']);
  }, []);
  React.useEffect(() => {
    if (eventRecord.data) {
      const leaveFeedback = ['noAttendance', 'full'].includes(eventRecord.data.flow_option || '');
      navigate(
        leaveFeedback
          ? `/website/event-feedback/${eventId}`
          : formatEventUrl(eventRecord.data?.title || 'event-title', eventId),
      );
    }
  }, [eventRecord.data]);
  return <Spinner animation="border" size="sm" role="status" aria-hidden="true" />;
};
